import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subject} from 'rxjs/Subject';

@Component({
    selector: 'checkit-checkin',
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="checkin_content">
            <div>
                <img src="assets/Checkit_RGB_750px.png" width="240">
                <p>Download the Checkit app to check people into your event.</p>
                <p><a [href]="'https://'+subdomain+'.checkit.events/iosapp'">App Store</a> &bull; <a href="'https://'+subdomain+'.checkit.events/androidapp'">Play Store</a></p>
            </div>
        </div>
    `,
    styles: [`
        #main_content { background:#EEF2F5;font-family: Helvetica; font-size:18px;  }
        .checkin_content { max-width: 320px; height: 60vh; display: flex; align-items: center; justify-content: center; margin: auto;
        text-align: center; height:100vh; width:100vw; }
        .checkin_content img { padding-bottom:50px;  }
        .checkin_content a { color: blue; }
    `]
})
export class CheckinComponent implements OnInit {

    private $destroy: Subject<boolean> = new Subject();
    code = '123';
    subdomain = 'dev';

    constructor(private route: ActivatedRoute) {
        route.params.takeUntil(this.$destroy).subscribe(params => {
            if (params.hasOwnProperty('checkinId')) {
                this.code = params.checkinId;
                //const metaStr = '<meta name="" content="app-id=1374670836, app-argument=' + params.checkinId + '" />';
                const metaEl = document.createElement('meta');
                metaEl.setAttribute('name', 'apple-itunes-app');
                metaEl.setAttribute('content', 'app-id=1374670836, app-argument=' + params.checkinId )
                const headEl = document.getElementsByTagName('head')[0];
                headEl.appendChild(metaEl);
            }
        })
        const location = window.document.location.href;
        if(/localhost:/.test(location)){
            this.subdomain = 'dev';
        }else{
            this.subdomain = location.split('://')[1].split('.checkit')[0];
        }
    }

    ngOnInit() {
        try {
            window.location.href = 'checkit://' + this.code;
        } catch (err) {
            console.log(err);
        }

    }
    ngOnDestroy(){
        this.$destroy.next();this.$destroy.complete();
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/checkin/checkin.component.ts